
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import "../styles/marketsurvey.css";
import { Country, City } from "country-state-city";
import { supabase } from "../supabase";
import { generateWord } from "../utils/wordGenerator.js";
console.log("🔥 LIVE MARKETSURVEY FILE CONFIRMED 🔥");
function Marketsurvey({ language, setLanguage  }) {
const [surveyContext, setSurveyContext] = useState({
  studyId: "",
  requestRef: "",
  storageKey: "",
});
const GENERATION_STATUS_KEY = "market-survey-generation-status";
const [generationStatus, setGenerationStatus] = useState(null);
const [generationNow, setGenerationNow] = useState(Date.now());
const abortControllerRef = useRef(null);
const cancelGenerationRef = useRef(false);
const isGenerating = Boolean(generationStatus);
const [generationCompleted, setGenerationCompleted] = useState(false);
const [attachmentFiles, setAttachmentFiles] = useState([]);
useEffect(() => {
  const protectMarketSurvey = async () => {
    // 1) لازم يكون المستخدم مسجل دخول
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (!session?.user) {
      window.location.replace("/login");
      return;
    }

    // 2) لازم يكون وافق على الشروط
    const termsAccepted =
      localStorage.getItem("terms_feasibility_accepted") === "true";

    if (!termsAccepted) {
      window.location.replace("/terms/feasibility");
      return;
    }

    // 3) لازم يكون الرابط ناتج عن طلب دراسة
    const params = new URLSearchParams(window.location.search);

    const studyId = params.get("study_id");
    const requestRef = params.get("request_ref");

    if (!studyId || !requestRef) {
      window.location.replace("/payment");
      return;
    }

    // 4) نتأكد أن الدراسة تخص نفس المستخدم
    const { data: study, error: studyError } = await supabase
      .from("studies")
      .select("id, order_id")
      .eq("id", studyId)
      .eq("user_id", session.user.id)
      .maybeSingle();

    if (studyError || !study?.order_id) {
      window.location.replace("/payment");
      return;
    }

    // 5) نتأكد أن الطلب المرتبط بالدراسة يخص نفس المستخدم ومصرح له بالدخول
    const { data: order, error: orderError } = await supabase
      .from("orders")
      .select("id, request_ref, status")
      .eq("id", study.order_id)
      .eq("user_id", session.user.id)
      .eq("request_ref", requestRef)
      .maybeSingle();

    if (
      orderError ||
      !order ||
      order.status !== "paid"
    ) {
      window.location.replace("/payment");
      return;
    }
  };

  protectMarketSurvey();
}, []);

useEffect(() => {
  const elements = document.querySelectorAll("[data-ar][data-en]");
  elements.forEach((el) => {
    const v = el.getAttribute(language === "ar" ? "data-ar" : "data-en");
    if (v !== null) el.textContent = v;
  });
  const placeholders = document.querySelectorAll("[data-ph-ar][data-ph-en]");
  placeholders.forEach((el) => {
    const ph = el.getAttribute(language === "ar" ? "data-ph-ar" : "data-ph-en");
    if (ph !== null) el.setAttribute("placeholder", ph);
  });
}, [language]);

 function currentLang() {
  return language;
}

  function mapCountry(c, lang) {
    return {
      value: c.name,
      label: lang === "ar" ? c.name : c.name,
    };
  }

  function mapCity(city, lang) {
    return {
      value: city.name,
      label: lang === "ar" ? city.name : city.name,
    };
  }

  useEffect(() => {
    const countriesRaw = Country.getAllCountries();

    const countriesByValue = new Map(countriesRaw.map((c) => [c.name, c]));
    const citiesCache = new Map();
    const LOC = {};

    Object.defineProperty(LOC, "countries", {
      enumerable: true,
      get() {
        const lang = currentLang();
        return countriesRaw.map((c) => mapCountry(c, lang));
      },
    });

    LOC.citiesByCountry = new Proxy(
      {},
      {
        get(target, prop) {
          const countryValue = String(prop || "");
          const lang = currentLang();
          const cacheKey = `${countryValue}|${lang}`;

          if (citiesCache.has(cacheKey)) return citiesCache.get(cacheKey);

          const countryObj = countriesByValue.get(countryValue);
          if (!countryObj) return [];

          const citiesRaw = City.getCitiesOfCountry(countryObj.isoCode) || [];
          const mapped = citiesRaw.map((c) => mapCity(c, lang));

          citiesCache.set(cacheKey, mapped);
          return mapped;
        },
      }
    );

    window.LOCATIONS_DATA = LOC;

    function applyTranslations() {
      const lang = currentLang();

      document.querySelectorAll("[data-ar][data-en]").forEach((el) => {
        const v = el.getAttribute(lang === "ar" ? "data-ar" : "data-en");
        if (v !== null) el.textContent = v;
      });

      document.querySelectorAll("[data-ph-ar][data-ph-en]").forEach((el) => {
        const ph = el.getAttribute(
          lang === "ar" ? "data-ph-ar" : "data-ph-en"
        );
        if (ph !== null) el.setAttribute("placeholder", ph);
      });

      const titleEl = document.querySelector("title[data-ar][data-en]");
      if (titleEl) {
        titleEl.textContent = titleEl.getAttribute(
          lang === "ar" ? "data-ar" : "data-en"
        );
      }
    }

    const obs = new MutationObserver(() => applyTranslations());

    // obs.observe(document.documentElement, {
    //   attributes: true,
    //   attributeFilter: ["lang", "dir"],
    // });

    applyTranslations();

    return () => {
      obs.disconnect();
    };
  }, []);

const GENERATE_ENDPOINT =
  process.env.REACT_APP_GENERATE_ENDPOINT ||
  "https://api.al-jabriyah.com/generate";

  useEffect(() => {
    const rawStatus = localStorage.getItem(GENERATION_STATUS_KEY);
    if (!rawStatus) return;

    try {
      const parsed = JSON.parse(rawStatus);
      if (parsed?.startedAt) {
        setGenerationStatus(parsed);
        setGenerationNow(Date.now());
      }
    } catch (_error) {
      localStorage.removeItem(GENERATION_STATUS_KEY);
    }
  }, []);

  useEffect(() => {
    if (!generationStatus) return undefined;

    const timer = window.setInterval(() => {
      setGenerationNow(Date.now());
    }, 1000);

    return () => window.clearInterval(timer);
  }, [generationStatus]);

  function formatGenerationTime(startedAt) {
    const elapsed = Math.max(0, Math.floor((generationNow - Number(startedAt || Date.now())) / 1000));
    const minutes = String(Math.floor(elapsed / 60)).padStart(2, "0");
    const seconds = String(elapsed % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  }

  function startGenerationStatus(payload) {
    const nextStatus = {
      startedAt: Date.now(),
      requestId: payload?.request_id || surveyContext.requestRef || "",
      projectName: payload?.project_name || "",
      endpoint: GENERATE_ENDPOINT,
    };

    localStorage.setItem(GENERATION_STATUS_KEY, JSON.stringify(nextStatus));
    setGenerationStatus(nextStatus);
    setGenerationNow(Date.now());
  }

  function clearGenerationStatus() {
    localStorage.removeItem(GENERATION_STATUS_KEY);
    setGenerationStatus(null);
  }

  function handleCancelGeneration() {
    cancelGenerationRef.current = true;
    abortControllerRef.current?.abort();
    clearGenerationStatus();
    showErrorBox(
      language === "ar"
        ? "تم إلغاء توليد الدراسة من الصفحة."
        : "Study generation was canceled from this page."
    );
  }

  const UI_TEXT = {
    ar: {
      required: "هذا الحقل مطلوب.",
      selectCountry: "اختر دولة أو أكثر",
      selectCity: "اختر مدينة أو أكثر (اختياري)",
      generating: "جارٍ توليد الدراسة...",
      success: "شكرًا على استخدام خدمات شركة الجبرية",
      fixErrors: "يرجى تعبئة الحقول المطلوبة.",
      networkError: "شكراً على استخدام خدمات شركة الجبرية.",
    },
    en: {
      required: "This field is required.",
      selectCountry: "Select one or more countries",
      selectCity: "Select one or more cities (optional)",
      generating: "Generating study...",
      success: "Thank you for using Al-Jabriya services",
      fixErrors: "Please fill in the required fields.",
      networkError: "Network error. Please try again.",
    },
  };

  const COUNTRY_LABEL_OVERRIDES_AR = {
    Turkey: "تركيا",
    Turkiye: "تركيا",
  };

  let _allCountriesCache = [];
  let _allCitiesCache = [];

  function getSurveyParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      studyId: params.get("study_id") || "",
      requestRef: params.get("request_ref") || "",
    };
  }

  function getStorageKey(ctx = surveyContext) {
    return ctx.storageKey || "";
  }

  function getStudyResultKey(ctx = surveyContext) {
    const keyPart = ctx.studyId || ctx.requestRef || "";
    return keyPart ? `study-result:${keyPart}` : "study_result";
  }

  function getSavedStudyResult(ctx = surveyContext) {
    const scopedKey = getStudyResultKey(ctx);
    return (
      (scopedKey !== "study_result" ? localStorage.getItem(scopedKey) : null) ||
      localStorage.getItem("study_result")
    );
  }

  function saveStudyResult(study, ctx = surveyContext) {
    const serialized = JSON.stringify(study);
    localStorage.setItem("study_result", serialized);

    const scopedKey = getStudyResultKey(ctx);
    if (scopedKey !== "study_result") {
      localStorage.setItem(scopedKey, serialized);
    }
  }

  function getProgressMeta(formDataLike) {
    const form = document.querySelector("#surveyForm");
    if (!form) return { step: 1, progress: 0 };

    const allNamedFields = Array.from(
      form.querySelectorAll("input[name], select[name], textarea[name]")
    ).filter((field) => field.name && !field.disabled && field.type !== "hidden");

    const uniqueNames = Array.from(new Set(allNamedFields.map((field) => field.name)));
    const answers = formDataLike || new FormData(form);
    const completedCount = uniqueNames.filter((name) => {
      const values = answers.getAll(name).filter((value) => String(value || "").trim() !== "");
      return values.length > 0;
    }).length;

    const progress = uniqueNames.length
      ? Math.min(100, Math.round((completedCount / uniqueNames.length) * 100))
      : 0;
    const step = progress >= 100 ? 2 : 1;

    return { step, progress };
  }

  function saveDraftLocally(ctx = surveyContext) {
    const storageKey = getStorageKey(ctx);
    const form = document.querySelector("#surveyForm");
    if (!storageKey || !form) return;

    const fd = new FormData(form);
    const values = {};

    Array.from(form.querySelectorAll("input[name], select[name], textarea[name]")).forEach((field) => {
      if (!field.name || field.disabled) return;

      if (field.type === "file") return;

      if (field.type === "checkbox") {
        if (!values[field.name]) values[field.name] = [];
        if (field.checked) values[field.name].push(field.value);
        return;
      }

      if (field.type === "radio") {
        if (field.checked) values[field.name] = field.value;
        return;
      }

      values[field.name] = field.value;
    });

    const meta = getProgressMeta(fd);
    localStorage.setItem(
      storageKey,
      JSON.stringify({
        values,
        meta,
        savedAt: new Date().toISOString(),
      })
    );
  }

  function restoreDraftLocally(ctx = surveyContext) {
    const storageKey = getStorageKey(ctx);
    const form = document.querySelector("#surveyForm");
    if (!storageKey || !form) return;

    const raw = localStorage.getItem(storageKey);
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw);
      const values = parsed?.values || {};

      Array.from(form.querySelectorAll("input[name], select[name], textarea[name]")).forEach((field) => {
        if (!field.name || field.type === "file") return;

        const value = values[field.name];
        if (value === undefined) return;

        if (field.type === "checkbox") {
          const selectedValues = Array.isArray(value) ? value : [value];
          field.checked = selectedValues.includes(field.value);
          return;
        }

        if (field.type === "radio") {
          field.checked = value === field.value;
          return;
        }

        field.value = value;
      });

      const countryHidden = document.querySelector("#countrySelect");
      const countryDisplay = document.querySelector("#countryDisplay");
      const cityHidden = document.querySelector("#citySelect");
      const cityDisplay = document.querySelector("#cityDisplay");

      if (countryHidden?.value && countryDisplay) {
        countryDisplay.value = countryHidden.value;
      }

      if (cityHidden?.value && cityDisplay) {
        cityDisplay.value = cityHidden.value;
      }
    } catch (error) {
      console.error("Failed to restore survey draft:", error);
    }
  }

  async function syncSurveyProgress(ctx = surveyContext) {
    if (!ctx.studyId) return;

    const form = document.querySelector("#surveyForm");
    if (!form) return;

    const fd = new FormData(form);
    const meta = getProgressMeta(fd);
    const isStarted = meta.progress > 0;

    const { error } = await supabase
      .from("studies")
      .update({
        survey_current_step: meta.step,
        survey_progress: meta.progress,
        status: isStarted ? "data_collection" : "waiting_for_client",
        last_update_note: isStarted
          ? "Client is filling in the market survey."
          : "Waiting for the client to start the survey.",
        last_updated_at: new Date().toISOString(),
      })
      .eq("id", ctx.studyId);

    if (error) {
      console.error("Failed to sync survey progress:", error);
    }
  }

  async function resolveSurveyContext() {
    const params = getSurveyParams();
    let { studyId, requestRef } = params;

    if (!studyId && requestRef) {
      const { data: orderData } = await supabase
        .from("orders")
        .select("id")
        .eq("request_ref", requestRef)
        .maybeSingle();

      if (orderData?.id) {
        const { data: studyData } = await supabase
          .from("studies")
          .select("id")
          .eq("order_id", orderData.id)
          .maybeSingle();

        studyId = studyData?.id || "";
      }
    }

    if (studyId && !requestRef) {
      const { data: studyData } = await supabase
        .from("studies")
        .select("order_id")
        .eq("id", studyId)
        .maybeSingle();

      if (studyData?.order_id) {
        const { data: orderData } = await supabase
          .from("orders")
          .select("request_ref")
          .eq("id", studyData.order_id)
          .maybeSingle();

        requestRef = orderData?.request_ref || "";
      }
    }

    const storageKey = `market-survey-draft:${studyId || requestRef || "anonymous"}`;

    setSurveyContext({
      studyId,
      requestRef,
      storageKey,
    });
  }

 function getLang() {
  return language;
}

  // function setLang(lang) {
  //   localStorage.setItem(LANG_STORAGE_KEY, lang);
  //   applyLang(lang);
  // }



  function ensurePlaceholderOption(selectEl, label) {
    if (!selectEl) return;

    if (selectEl.tagName !== "SELECT") {
      selectEl.placeholder = label;
      return;
    }

    const first = selectEl.options[0];

    if (!first || first.value !== "") {
      const opt = document.createElement("option");
      opt.value = "";
      opt.textContent = label;
      opt.disabled = true;
      opt.selected = true;
      selectEl.insertBefore(opt, selectEl.firstChild);
    } else {
      first.textContent = label;
      first.disabled = true;
    }
  }

  function showThankYou(message) {
    const box = document.querySelector("#thankYouMessage");
    if (!box) return;

    box.textContent = message;
    box.style.display = "block";
    box.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function hideThankYou() {
    const box = document.querySelector("#thankYouMessage");
    if (!box) return;

    box.style.display = "none";
    box.textContent = "";
  }

  function showErrorBox(msg) {
    const errorBox = document.querySelector("#errorBox");
    if (!errorBox) return;

    errorBox.textContent = msg;
    errorBox.style.display = "block";
  }

  function hideErrorBox() {
    const errorBox = document.querySelector("#errorBox");
    if (!errorBox) return;

    errorBox.style.display = "none";
    errorBox.textContent = "";
  }

 function markFieldError(field, message) {
  if (!field) return;

  field.classList.add("field-error");

  const errorContainer =
    field.type === "checkbox" || field.type === "radio"
      ? field.closest(".field") || field.closest(".question") || field.parentElement
      : field.parentElement;

  if (!errorContainer) return;

  let msgEl = errorContainer.querySelector(":scope > .field-error-msg");

  if (!msgEl) {
    msgEl = document.createElement("div");
    msgEl.className = "field-error-msg";
    errorContainer.appendChild(msgEl);
  }

  msgEl.textContent = message || UI_TEXT[getLang()].required;
}

  function clearFieldError(field) {
    if (!field) return;

    field.classList.remove("field-error");

    const msgEl = field.parentElement?.querySelector(".field-error-msg");
    if (msgEl) msgEl.textContent = "";
  }

  function isEmptyValue(val) {
    return val === null || val === undefined || String(val).trim() === "";
  }

  function validateSingleField(field) {
    const lang = getLang();

    const isRequired =
      field.hasAttribute("required") ||
      field.getAttribute("aria-required") === "true";

    if (!isRequired) {
      clearFieldError(field);
      return true;
    }

    if (field.type === "checkbox") {
      const ok = field.checked;
      if (!ok) {
        console.log("Validation failed: checkbox", {
          id: field.id,
          name: field.name,
          value: field.value,
        });
      }
      ok
        ? clearFieldError(field)
        : markFieldError(field, UI_TEXT[lang].required);
      return ok;
    }

    if (field.type === "radio") {
      const name = field.name;
      if (!name) return true;

      const group = Array.from(
        document.querySelectorAll(
          `input[type="radio"][name="${CSS.escape(name)}"]`
        )
      );

      const ok = group.some((r) => r.checked);
      const first = group[0] || field;

      if (!ok) {
        console.log("Validation failed: radio group", {
          name,
          fieldId: field.id,
          groupLength: group.length,
        });
      }

      ok
        ? clearFieldError(first)
        : markFieldError(first, UI_TEXT[lang].required);

      return ok;
    }

    if (field.id === "countryDisplay") {
      const hiddenCountry = document.querySelector("#countrySelect");
      const ok =
        (hiddenCountry && !isEmptyValue(hiddenCountry.value)) ||
        !isEmptyValue(field.value);

      if (!ok) {
        console.log("Validation failed: countryDisplay", {
          hiddenCountryValue: hiddenCountry?.value,
          displayValue: field.value,
        });
      }

      ok
        ? clearFieldError(field)
        : markFieldError(field, UI_TEXT[lang].required);

      return ok;
    }

    if (field.id === "cityDisplay") {
      clearFieldError(field);
      return true;
    }

    const ok = !isEmptyValue(field.value);
    if (!ok) {
      console.log("Validation failed: field empty", {
        id: field.id,
        name: field.name,
        type: field.type,
        value: field.value,
      });
    }

    if (ok && field.id === "problem_solved" && String(field.value).trim().length < 10) {
      markFieldError(
        field,
        lang === "ar"
          ? "يرجى كتابة وصف أوضح للمشكلة الأساسية (10 أحرف على الأقل)."
          : "Please describe the main problem more clearly (at least 10 characters)."
      );
      return false;
    }

    ok
      ? clearFieldError(field)
      : markFieldError(field, UI_TEXT[lang].required);

    return ok;
  }

  function validateForm() {
    hideErrorBox();
    hideThankYou();

    const form = document.querySelector("#surveyForm");
    if (!form) return false;

    let ok = true;

    const fields = Array.from(form.querySelectorAll("input, select, textarea"));

    const groupNames = Array.from(form.querySelectorAll("[data-required-group]"))
      .map((el) => el.getAttribute("data-required-group"))
      .filter(Boolean);

    const uniqueGroups = Array.from(new Set(groupNames));
    const invalidGroups = [];

    uniqueGroups.forEach((g) => {
      const groupInputs = Array.from(
        form.querySelectorAll(`input[name="${CSS.escape(g)}"]`)
      );

      const anyChecked = groupInputs.some((x) => x.checked);

      if (!anyChecked) {
        ok = false;
        invalidGroups.push({ group: g, groupCount: groupInputs.length });
        console.log("Validation failed: required group", {
          group: g,
          groupCount: groupInputs.length,
        });
        if (groupInputs[0]) {
          markFieldError(groupInputs[0], UI_TEXT[getLang()].required);
        }
      } else {
        if (groupInputs[0]) clearFieldError(groupInputs[0]);
      }
    });

    if (invalidGroups.length > 0) {
      console.log("Invalid checkbox groups:", invalidGroups);
    }

    fields.forEach((f) => {
      if (f.disabled) return;
      if (f.type === "hidden") return;
      if (f.name && uniqueGroups.includes(f.name)) return;

      const oneOk = validateSingleField(f);
      if (!oneOk) ok = false;
    });

    if (!ok) {
      showErrorBox(UI_TEXT[getLang()].fixErrors);
    }

    return ok;
  }

  function _normalizeCountryLabel(item, lang) {
    if (!item) return item;

    if (lang === "ar") {
      const ov = COUNTRY_LABEL_OVERRIDES_AR[item.value];
      if (ov) {
        item = { ...item, label: ov };
      }
    }

    return item;
  }

  function _matchQuery(item, q) {
    const s = String(q || "").trim().toLowerCase();
    if (!s) return true;

    const a = String(item.label || "").toLowerCase();
    const b = String(item.value || "").toLowerCase();

    return a.includes(s) || b.includes(s);
  }

  async function loadCountries() {
    if (
      window.LOCATIONS_DATA &&
      Array.isArray(window.LOCATIONS_DATA.countries)
    ) {
      return window.LOCATIONS_DATA.countries;
    }

    return [];
  }

  async function loadCities(countryValue) {
    if (window.LOCATIONS_DATA && window.LOCATIONS_DATA.citiesByCountry) {
      return window.LOCATIONS_DATA.citiesByCountry[countryValue] || [];
    }
    return [];
  }

  async function loadCountriesAndInit() {
    const lang = getLang();

    const countryDisplay = document.querySelector("#countryDisplay");
    const countryHidden = document.querySelector("#countrySelect");
    const countryPanel = document.querySelector("#countryPanel");
    const countrySearch = document.querySelector("#countrySearch");
    const countryOptions = document.querySelector("#countryOptions");
    const countrySS = document.querySelector("#countrySS");

    const cityDisplay = document.querySelector("#cityDisplay");
    const cityHidden = document.querySelector("#citySelect");
    const cityPanel = document.querySelector("#cityPanel");
    const citySearch = document.querySelector("#citySearch");
    const cityOptions = document.querySelector("#cityOptions");
    const citySS = document.querySelector("#citySS");

    if (!countryDisplay || !countryHidden || !cityDisplay || !cityHidden) return;

    ensurePlaceholderOption(countryDisplay, UI_TEXT[lang].selectCountry);
    ensurePlaceholderOption(cityDisplay, UI_TEXT[lang].selectCity);

    const selectedCountries = [];
    const selectedCities = [];

    const showPanel = (panel) => {
      if (!panel) return;
      panel.hidden = false;
      panel.style.display = "block";
      panel.classList.remove("is-hidden");
    };

    const hidePanel = (panel) => {
      if (!panel) return;
      panel.hidden = true;
      panel.style.display = "none";
      panel.classList.add("is-hidden");
    };

    const isPanelOpen = (panel) =>
      panel && !panel.hidden && !panel.classList.contains("is-hidden");

    const togglePanel = (panelToToggle, panelToClose) => {
      if (isPanelOpen(panelToToggle)) {
        hidePanel(panelToToggle);
      } else {
        showPanel(panelToToggle);
        hidePanel(panelToClose);
      }
    };

    const syncDisplay = () => {
      countryHidden.value = selectedCountries.map((x) => x.value).join(", ");
      countryDisplay.value = selectedCountries.map((x) => x.label).join("، ");

      cityHidden.value = selectedCities.map((x) => x.value).join(", ");
      cityDisplay.value = selectedCities.map((x) => x.label).join("، ");
    };

    const toggleInList = (arr, item) => {
      const idx = arr.findIndex((x) => x.value === item.value);
      if (idx >= 0) arr.splice(idx, 1);
      else arr.push(item);
    };

    const renderList = (listEl, items, filterText, onPick, selectedArr) => {
      if (!listEl) return;

      listEl.innerHTML = "";

      const filtered = (items || []).filter((it) => _matchQuery(it, filterText));

      if (!filtered.length) {
        const empty = document.createElement("div");
        empty.className = "ss-empty";
        empty.textContent = getLang() === "ar" ? "لا توجد نتائج" : "No results";
        listEl.appendChild(empty);
        return;
      }

      filtered.forEach((it) => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "ss-option";

        if (selectedArr.some((x) => x.value === it.value)) {
          btn.classList.add("selected");
        }

        btn.textContent =
          (selectedArr.some((x) => x.value === it.value) ? "✓ " : "") + it.label;

        btn.onclick = () => onPick(it);
        listEl.appendChild(btn);
      });
    };

    const renderCountries = () => {
      renderList(
        countryOptions,
        _allCountriesCache,
        countrySearch?.value,
        async (countryItem) => {
          toggleInList(selectedCountries, countryItem);
          clearFieldError(countryDisplay);
          hidePanel(countryPanel);
          hidePanel(cityPanel);

          let allCities = [];

          for (const c of selectedCountries) {
            const cities = await loadCities(c.value);
            cities.forEach((city) => {
              if (!allCities.some((x) => x.value === city.value)) {
                allCities.push(city);
              }
            });
          }

          _allCitiesCache = allCities;
          cityDisplay.disabled = selectedCountries.length === 0;
          selectedCities
            .filter((selectedCity) =>
              !allCities.some((city) => city.value === selectedCity.value)
            )
            .forEach((staleCity) => toggleInList(selectedCities, staleCity));

          syncDisplay();
          renderCountries();
          renderCities();
        },
        selectedCountries
      );
    };

    const renderCities = () => {
      renderList(
        cityOptions,
        _allCitiesCache,
        citySearch?.value,
        (cityItem) => {
          toggleInList(selectedCities, cityItem);
          clearFieldError(cityDisplay);
          hidePanel(cityPanel);

          syncDisplay();
          renderCities();
        },
        selectedCities
      );
    };

    try {
      const countriesRaw = await loadCountries();
      _allCountriesCache = (countriesRaw || []).map((c) =>
        _normalizeCountryLabel(c, lang)
      );

      renderCountries();
      renderCities();
    } catch (e) {
      console.error("Countries load error:", e);
    }

    countryDisplay.onclick = () => {
      togglePanel(countryPanel, cityPanel);
    };

    cityDisplay.onclick = () => {
      if (!cityDisplay.disabled) {
        togglePanel(cityPanel, countryPanel);
      }
    };

    const closePanels = () => {
      hidePanel(countryPanel);
      hidePanel(cityPanel);
    };

    const handleOutsidePointerDown = (event) => {
      const target = event.target;
      if (
        !countrySS?.contains(target) &&
        !citySS?.contains(target)
      ) {
        closePanels();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") closePanels();
    };

    document.addEventListener("pointerdown", handleOutsidePointerDown);
    document.addEventListener("keydown", handleEscape);

    if (countrySearch) countrySearch.oninput = renderCountries;
    if (citySearch) citySearch.oninput = renderCities;
  }

  function collectFormData() {
    const form = document.querySelector("#surveyForm");
    const lang = getLang();

    if (!form) return null;

    const fd = new FormData(form);
    fd.append("ui_lang", lang);

    const reportLang =
      form.querySelector('input[name="report_language"]:checked')?.value || lang;

    fd.set("report_language", reportLang);

    const projectName =
      form.querySelector('[name="project_name"]')?.value?.trim() || "";

    fd.set("study_name_raw", projectName);

    const done = new Set();

    Array.from(form.querySelectorAll("input[name], select[name], textarea[name]")).forEach(
      (el) => {
        const name = el.name;

        if (
          !name ||
          name.startsWith("ai__") ||
          name.startsWith("label__") ||
          name === "ui_lang" ||
          name === "report_language"
        ) {
          return;
        }

        if (done.has(name)) return;
        done.add(name);

        let labelText = "";

        if (el.id) {
          const byFor = form.querySelector(`label[htmlFor="${el.id}"]`);
          if (byFor) labelText = byFor.textContent || "";
        }

        if (!labelText) {
          const fieldWrap = el.closest(".field, .question, .form-group");
          const lab = fieldWrap?.querySelector("label, legend, h3, h4, .label");
          if (lab) labelText = lab.textContent || "";
        }

        labelText = String(labelText).replace(/\s+/g, " ").trim();

        if (labelText) {
          fd.set(`label__${name}`, labelText);
        }
      }
    );

    return fd;
  }

  function buildGeneratePayload(fd) {
    const payload = {};

    for (const [key, value] of fd.entries()) {
      if (key.startsWith("label__") || key.startsWith("ai__")) continue;

      if (Object.prototype.hasOwnProperty.call(payload, key)) {
        payload[key] = Array.isArray(payload[key])
          ? [...payload[key], value]
          : [payload[key], value];
      } else {
        payload[key] = value;
      }
    }

    const demandLevel = String(payload.first_year_demand || "").trim();
    const demandValue = String(payload.first_year_demand_value || "").trim();
    const demandUnit = String(payload.first_year_demand_unit || "").trim();

    if (demandValue) {
      payload.first_year_demand = [demandLevel, `${demandValue} ${demandUnit}`.trim()]
        .filter(Boolean)
        .join(" - ");
    }
    payload.language = language;
    payload.report_language = payload.report_language || language;
    payload.ui_lang = language;

    return payload;
  }

async function exportSavedWord() {
  console.log("✅ EXPORT SAVED WORD CLICKED");
  try {
    const savedStudy = getSavedStudyResult();

    if (!savedStudy) {
      alert("لا توجد دراسة محفوظة. يجب توليد دراسة ناجحة مرة واحدة أولًا.");
      return;
    }

    const study = JSON.parse(savedStudy);

    await generateWord({
      ...study,
      report_language: study.report_language || language,
      language: study.language || language,
      ui_lang: study.ui_lang || language,
    });

    console.log("✅ تم توليد ملفات Word من الدراسة المحفوظة");
  } catch (error) {
    console.error("❌ فشل توليد Word من الدراسة المحفوظة:", error);
    alert("حدث خطأ أثناء إعادة توليد ملف Word.");
  }
}
  
  async function handleGenerateClick() {
    const lang = getLang();
if (generationCompleted) {
  showErrorBox(
    lang === "ar"
      ? "تم توليد هذه الدراسة بنجاح مسبقًا، ولا يمكن إعادة توليدها."
      : "This study has already been generated successfully and cannot be generated again."
  );
  return;
}
    if (isGenerating) {
      showErrorBox(
        lang === "ar"
          ? "يوجد توليد دراسة جارٍ الآن. يمكنك الانتظار أو الضغط على إلغاء."
          : "A study is already being generated. Please wait or cancel it."
      );
      return;
    }

    console.log("Before validation");

if (!validateForm()) {
    console.log("VALIDATION FAILED");
    return;
}

console.log("VALIDATION PASSED");

    hideErrorBox();
    hideThankYou();
    cancelGenerationRef.current = false;
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

   try {
      const accessMessage = lang === "ar"
        ? "يلزم تأكيد طلب الدراسة بكوبون خصم 100% من صفحة الدفع أولًا."
        : "Confirm your study request with a 100% coupon on the payment page first.";
      const { data: authData, error: authError } = await supabase.auth.getUser();
      if (authError || !authData?.user || !surveyContext.studyId) {
        throw new Error(accessMessage);
      }
      const { data: accessStudy, error: studyAccessError } = await supabase
        .from("studies")
        .select("order_id")
        .eq("id", surveyContext.studyId)
        .eq("user_id", authData.user.id)
        .single();
      if (studyAccessError || !accessStudy?.order_id) throw new Error(accessMessage);
      const { data: accessOrder, error: orderAccessError } = await supabase
        .from("orders")
        .select("coupon_code, base_amount, discount")
        .eq("id", accessStudy.order_id)
        .eq("user_id", authData.user.id)
        .eq("payment_method", "coupon")
        .eq("status", "paid")
        .eq("total", 0)
        .single();
      if (orderAccessError || !accessOrder?.coupon_code ||
          Number(accessOrder.base_amount) <= 0 ||
          Number(accessOrder.discount) !== Number(accessOrder.base_amount)) {
        throw new Error(accessMessage);
      }

      const fd = collectFormData();
      if (!fd) throw new Error("Form not found");
      console.log("=== RAW FORM DATA ===");

     for (const [key, value] of fd.entries()) {
     console.log(key, value);
}
      fd.append("request_id", surveyContext.requestRef || "");

      // طباعة البيانات المرسلة
      console.log("=== FORM DATA SENT ===");
      const formDataObj = {};
      for (let [key, value] of fd.entries()) {
        if (!key.startsWith("label__") && !key.startsWith("ai__")) {
          formDataObj[key] = value;
        }
      }
      console.table(formDataObj);
const payload = buildGeneratePayload(fd);

console.log("=== PAYLOAD ===");
console.log(payload);
     
  
console.log("=== PAYLOAD ===");
console.log(payload);
console.log("ENDPOINT =", GENERATE_ENDPOINT);
console.log("BEFORE FETCH");

startGenerationStatus(payload);

const res = await fetch(GENERATE_ENDPOINT, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    "x-api-key": "alj_9X#study_2026_apikey",
  },
  body: JSON.stringify(payload),
  signal: abortController.signal,
});

  if (!res.ok) {
    let errText = "";

    try {
      const j = await res.json();
      errText = j?.error || JSON.stringify(j);
    } catch {}

    throw new Error(errText || `HTTP ${res.status}`);
  }

  
const data = await res.json();
console.log("=== RESPONSE ===", data);
console.log("=== STUDY ===", data.study);
console.log("=== EXECUTIVE SUMMARY ===", data.study?.executive_summary);

console.log("=== GENERATE RESPONSE ===", data);

if (data?.success === false || data?.error) {
  throw new Error(data?.message || data?.error || UI_TEXT[lang].networkError);
}

if (data?.study) {
const studyWithMeta = {
  ...data.study,

  // بيانات الغلاف من الاستبيان
  recipient_name: payload.recipient_name || "",
  project_name: payload.project_name || "",

  // القيم الكمية الأصلية من الاستبيان
  monthly_capacity: payload.monthly_capacity || "",
  capacity_unit: payload.capacity_unit || "",
  first_year_demand: payload.first_year_demand || "",
  first_year_demand_value: payload.first_year_demand_value || "",
  first_year_demand_unit: payload.first_year_demand_unit || "",

  report_language: language,
  language,
  ui_lang: language,
};

  saveStudyResult(studyWithMeta);
if (surveyContext.studyId) {
  const { error: completionError } = await supabase
    .from("studies")
    .update({
      generation_completed: true,
      generation_completed_at: new Date().toISOString(),
    })
    .eq("id", surveyContext.studyId);

  if (completionError) {
    console.error(
      "Failed to mark study generation as completed:",
      completionError
    );
  } else {
    setGenerationCompleted(true);
  }
}
  console.log("AFTER SAVE =", localStorage.getItem("study_result"));
  console.log("CLIENT NAME =", studyWithMeta.recipient_name);
  console.log("PROJECT NAME =", studyWithMeta.project_name);

  await generateWord(studyWithMeta);
}
// try {
//   let studyObj = data?.study || null;

//   if (!studyObj && typeof data?.raw === "string") {
//     try {
//       studyObj = JSON.parse(data.raw);
//     } catch (_err) {
//       studyObj = null;
//     }
//   }

//   if (!studyObj && typeof data?.response === "string") {
//     try {
//       studyObj = JSON.parse(data.response);
//     } catch (_err) {
//       studyObj = null;
//     }
//   }

//   if (studyObj) {
//     localStorage.setItem(
//       "study_result",
//       JSON.stringify(studyObj)
//     );
//   }
// } catch (err) {
//   console.warn("Failed to save study result:", err);
// }

saveDraftLocally();
await syncSurveyProgress();

if (surveyContext.studyId) {
  await supabase
    .from("studies")
    .update({
      survey_current_step: 2,
      survey_progress: 100,
      status: "analysis",
      last_update_note: "Survey submitted successfully.",
      last_updated_at: new Date().toISOString(),
    })
    .eq("id", surveyContext.studyId);
}

  showThankYou(UI_TEXT[lang].success);
  clearGenerationStatus();

} catch (e) {
  console.error("Generate Study Error:", e);

  if (e?.name === "AbortError" || cancelGenerationRef.current) {
    showErrorBox(
      lang === "ar"
        ? "تم إلغاء توليد الدراسة."
        : "Study generation was canceled."
    );
    clearGenerationStatus();
    return;
  }

  const displayMessage =
    e instanceof TypeError && e.message === "Failed to fetch"
      ? language === "ar"
        ? "تعذر الوصول إلى خادم التوليد. إذا كنت تجرب محليًا تأكد أن الباكند شغال، أو انتظر خدمة Render ثم حاول مرة أخرى."
        : "Could not reach the generation server. If you are testing locally, make sure the backend is running, or wait for the Render service and try again."
      : e.message || UI_TEXT[lang].networkError;

  showErrorBox(displayMessage);
  clearGenerationStatus();

} finally {
  abortControllerRef.current = null;
  cancelGenerationRef.current = false;
}
}


  function bindAttachmentsLogic() {
    const yes = document.querySelector("#attachmentsYes");
    const no = document.querySelector("#attachmentsNo");
    const files = document.querySelector("#attachmentsFiles");
    const wrap = document.querySelector("#attachmentsFiles_wrap");

    if (!yes || !no || !files || !wrap) return;

    const update = () => {
      if (yes.checked) {
        wrap.classList.remove("is-hidden");
        files.disabled = false;
     } else {
  wrap.classList.add("is-hidden");
  files.disabled = true;
  files.value = "";
  setAttachmentFiles([]);
}
    };

    yes.onchange = update;
    no.onchange = update;
    update();
  }

  function bindOtherOptionFields() {
    const form = document.querySelector("#surveyForm");
    if (!form) return;

    const others = Array.from(
      form.querySelectorAll('input[name$="_other"], textarea[name$="_other"]')
    );

    others.forEach((field) => {
      const base =
        field.getAttribute("data-other-for") || field.name.replace(/_other$/, "");

      if (!base || !field.id) return;

      const labelEl = form.querySelector(`label[htmlFor="${field.id}"]`);
      const ai = form.querySelector(`.ai-toggle[data-target="${field.id}"]`);

      const controls = () => Array.from(form.querySelectorAll(`input[name="${base}"]`));

      const setOtherChecked = (checked) => {
        const ctrls = controls();
        const other = ctrls.find((c) => c.value === "other");
        if (other) other.checked = checked;
      };

      const update = () => {
        const isOther = controls().some((c) => c.checked && c.value === "other");

        if (isOther) {
          if (labelEl) labelEl.style.display = "";
          field.style.display = "";
          field.disabled = false;
        } else {
          if (labelEl) labelEl.style.display = "none";
          field.style.display = "none";
          field.disabled = true;
          field.value = "";
        }
      };

      controls().forEach((c) => {
        c.onchange = update;
      });

      if (ai) {
        ai.onchange = () => {
          if (ai.checked) setOtherChecked(true);
          update();
          validateSingleField(field);
        };
      }

      update();
    });
  }

  function bindYesNoConditional({
    choiceName,
    yesValue,
    wrapId,
    inputId,
    aiToggleId,
    hiddenId,
    isFile,
    aiForcesYes = true,
  }) {
    const form = document.querySelector("#surveyForm");
    if (!form) return;

    const yesRadio = form.querySelector(
      `input[name="${choiceName}"][value="${yesValue}"]`
    );

    const noRadio = form.querySelector(
      `input[name="${choiceName}"]:not([value="${yesValue}"])`
    );

    const wrap = document.getElementById(wrapId);
    const input = document.getElementById(inputId);
    const ai = aiToggleId ? document.getElementById(aiToggleId) : null;
    const hidden = hiddenId ? document.getElementById(hiddenId) : null;

    if (!yesRadio || !noRadio || !wrap || !input) return;

    const show = () => {
      wrap.classList.remove("is-hidden");
      input.disabled = false;
      if (isFile) input.required = true;
    };

    const hide = () => {
      wrap.classList.add("is-hidden");
      input.disabled = true;
      input.required = false;
      input.value = "";
    };

    const update = () => {
      if (yesRadio.checked) {
        show();
      } else {
        hide();
      }

      if (hidden) hidden.value = yesRadio.checked ? "yes" : "no";
    };

    yesRadio.onchange = () => {
      update();
      validateSingleField(input);
    };

    noRadio.onchange = () => {
      update();
      validateSingleField(input);
    };

    if (ai) {
      ai.onchange = () => {
        if (ai.checked && aiForcesYes) {
          yesRadio.checked = true;
          show();
          if (hidden) hidden.value = "yes";
        } else {
          update();
        }

        validateSingleField(input);
      };
    }

    update();
  }

  function bindYesNoConditionals() {
    bindYesNoConditional({
      choiceName: "sub_segments_choice",
      yesValue: "yes",
      wrapId: "sub_segments_wrap",
      inputId: "sub_segments",
      aiToggleId: "ai_sub_segments",
      hiddenId: null,
      isFile: false,
    });

    bindYesNoConditional({
      choiceName: "has_market_data_choice",
      yesValue: "yes",
      wrapId: "market_data_file_wrap",
      inputId: "market_data_file",
      aiToggleId: "ai_has_market_data",
      hiddenId: "has_market_data",
      isFile: true,
      aiForcesYes: false,
    });

    bindYesNoConditional({
      choiceName: "seasonal_demand_choice",
      yesValue: "yes",
      wrapId: "season_periods_wrap",
      inputId: "season_periods",
      aiToggleId: "ai_season_periods",
      hiddenId: "seasonal_demand",
      isFile: false,
    });

    bindYesNoConditional({
      choiceName: "underserved_segments_choice",
      yesValue: "yes",
      wrapId: "underserved_segments_wrap",
      inputId: "underserved_segments_text",
      aiToggleId: "ai_underserved_segments_text",
      hiddenId: "underserved_segments",
      isFile: false,
    });
  }

  function bindCountryCitySearch() {
    loadCountriesAndInit();
  }

   // function bindLanguageButtons() {
 //   const btnAr = document.querySelector("#langToggleAr");
 //   const btnEn = document.querySelector("#langToggleEn");

 //   if (btnAr) btnAr.onclick = () => setLang("ar");
 //   if (btnEn) btnEn.onclick = () => setLang("en");
 // }

  function bindLiveValidation() {
    const form = document.querySelector("#surveyForm");
    if (!form) return;

    form.oninput = (e) => {
      const t = e.target;
      if (t && t.matches("input, textarea, select")) {
        validateSingleField(t);
      }
    };

    form.onchange = (e) => {
      const t = e.target;
      if (t && t.matches("input, textarea, select")) {
        validateSingleField(t);
      }
    };
  }

  useEffect(() => {
    // bindLanguageButtons();
    bindOtherOptionFields();
    bindYesNoConditionals();
    bindCountryCitySearch();
    bindAttachmentsLogic();
    bindLiveValidation();
   // bindGenerateButton();
   
  }, []);

  useEffect(() => {
    resolveSurveyContext();
  }, []);
useEffect(() => {
  const checkGenerationStatus = async () => {
    if (!surveyContext.studyId) return;

    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user) return;

    const { data, error } = await supabase
      .from("studies")
      .select("generation_completed")
      .eq("id", surveyContext.studyId)
      .eq("user_id", user.id)
      .maybeSingle();

    if (error) {
      console.error("Failed to check generation status:", error);
      return;
    }

    setGenerationCompleted(data?.generation_completed === true);
  };

  checkGenerationStatus();
}, [surveyContext.studyId]);
  useEffect(() => {
    if (!surveyContext.storageKey) return;

    const form = document.querySelector("#surveyForm");
    if (!form) return;

    restoreDraftLocally(surveyContext);
    bindOtherOptionFields();
    bindYesNoConditionals();
    bindAttachmentsLogic();

    const saveAndSync = () => {
      saveDraftLocally(surveyContext);
      syncSurveyProgress(surveyContext);
    };

    const handleInput = (event) => {
      if (event.target?.matches("input, select, textarea")) {
        window.clearTimeout(handleInput.timerId);
        handleInput.timerId = window.setTimeout(saveAndSync, 300);
      }
    };

    form.addEventListener("input", handleInput);
    form.addEventListener("change", handleInput);

    saveAndSync();

    return () => {
      form.removeEventListener("input", handleInput);
      form.removeEventListener("change", handleInput);
      window.clearTimeout(handleInput.timerId);
    };
  }, [surveyContext.storageKey]);

  return (

  <div
  className={`container ${language === "ar" ? "rtl" : ""}`}
  dir={language === "ar" ? "rtl" : "ltr"}
  lang={language}
>

    <div className="topbar">
      <div className="brand">
        <div className="logo" aria-hidden="true"></div>
        <div className="title">
          <h1 data-ar="منصة مكتب الجبرية الاستشاري" data-en="Al-Jabriya Consulting Platform">منصة مكتب الجبرية الاستشاري</h1>
          <p data-ar="استبيان معلومات — دراسات السوق والتحليل التجاري" data-en="Survey — Market Study & Business Analysis">
            استبيان معلومات — دراسات السوق والتحليل التجاري
          </p>
        </div>
      </div>

      <div className="lang-toggle" aria-label="Language toggle">


    <button
  type="button"
  id="langToggleAr"
  className={language === "ar" ? "active" : ""}
  onClick={() => setLanguage("ar")}
>
  AR
</button>

<button
  type="button"
  id="langToggleEn"
  className={language === "en" ? "active" : ""}
  onClick={() => setLanguage("en")}
>
  EN
</button>


      </div>
    </div>

    <div className="card">
      <div className="card-header">
        <h2
  data-ar="نموذج الاستبيان السوقي"
  data-en="Market Feasibility Survey Form"
>
  نموذج الاستبيان السوقي
</h2>
       <p
  data-ar="بعض الحقول اختيارية، وسيقوم الذكاء الاصطناعي بإثراء البيانات الناقصة تلقائيًا داخل الدراسة. ومع ذلك، يُرجى توفير جميع المعلومات المتاحة قدر الإمكان، لأن اكتمال البيانات يساعد على تحسين دقة وجودة الدراسة."
  data-en="Some fields are optional, and AI will enrich missing information automatically in the study. However, please provide all available information whenever possible, as more complete data helps improve the accuracy and quality of the study."
>
  بعض الحقول اختيارية، وسيقوم الذكاء الاصطناعي بإثراء البيانات الناقصة تلقائيًا داخل الدراسة. ومع ذلك، يُرجى توفير جميع المعلومات المتاحة قدر الإمكان، لأن اكتمال البيانات يساعد على تحسين دقة وجودة الدراسة.
</p>
      </div>

      <div className="card-body">
        <div id="errorBox"></div>
        <div id="thankYouMessage"></div>

<form id="surveyForm" encType="multipart/form-data">
<fieldset
  disabled={generationCompleted}
  style={{
    border: 0,
    padding: 0,
    margin: 0,
    minWidth: 0,
  }}
>
          {/* <!-- بيانات توجيه الدراسة --> */}
          <div className="section">
            <h3 data-ar="بيانات توجيه الدراسة" data-en="Study Recipient">بيانات توجيه الدراسة</h3>
            <div className="grid">
              <div className="field col-12">
                <label htmlFor="recipient_name">
                  <span data-ar="ادخل الاسم الذي سيتم توجيه الدراسة إليه (اسم العميل/الجهة)"
                        data-en="Enter the name the study will be addressed to (client/entity)">
                    ادخل الاسم الذي سيتم توجيه الدراسة إليه (اسم العميل/الجهة)
                  </span>
                  
                </label>
                <input type="text" id="recipient_name" name="recipient_name" required
                       data-ph-ar="مثال: شركة / اسم شخص / جهة"
                       data-ph-en="Example: Company / Person / Entity"
                       placeholder="مثال: شركة / اسم شخص / جهة" />
              </div>
            </div>
          </div>


          <div className="section">
            <h3 data-ar="لغة إخراج الدراسة" data-en="Report Language">لغة إخراج الدراسة</h3>
            <div className="grid">
              <div className="field col-12">
                <label>
                  <span data-ar="اختر لغة دراسة الجدوى والملخص والمصادر" data-en="Choose the language for the feasibility study, summary, and references">
                    اختر لغة دراسة الجدوى والملخص والمصادر
                  </span>
                  
                </label>

                <div className="radio-row">


    <label className="radio">
  <input
    type="radio"
    name="report_language"
    value="ar"
    checked={language === "ar"}
    onChange={() => setLanguage("ar")}
  />
  <span data-ar="العربية" data-en="Arabic">
    العربية
  </span>
</label>

<label className="radio">
  <input
    type="radio"
    name="report_language"
    value="en"
    checked={language === "en"}
    onChange={() => setLanguage("en")}
  />
  <span data-ar="الإنجليزية" data-en="English">
    الإنجليزية
  </span>
</label>


                </div>

                <div className="hint" data-ar="" data-en="Files will be generated in only one language to reduce time and cost.">
                  سيتم إنشاء الملفات بلغة واحدة فقط لتقليل الوقت والتكلفة.
                </div>
              </div>
            </div>
          </div>

          {/* <!-- أولًا: بيانات المشروع الأساسية --> */}
          <div className="section">
            <h3 data-ar="أولًا: بيانات المشروع الأساسية" data-en="1) Basic Project Information">أولًا: بيانات المشروع الأساسية</h3>

            <div className="grid">
              {/* <!-- 1 --> */}
              <div className="field col-6">
                <label htmlFor="project_name">
                  <span data-ar="1. اسم المشروع" data-en="1. Project Name">1. اسم المشروع</span>
                  
                </label>
                <input type="text" id="project_name" name="project_name" required
                       data-ph-ar="مثال: متجر قهوة"
                       data-ph-en="Example: Coffee Shop"
                       placeholder="مثال: متجر قهوة" />
              </div>

              {/* <!-- 2 --> */}
              <div className="field col-6">
                <label htmlFor="project_desc">
                  <span data-ar="2. وصف مختصر للمشروع" data-en="2. Brief Description of Product/Service">
                    2. وصف مختصر للمنتج أو الخدمة
                  </span>
                  
                </label>
                <input type="text" id="project_desc" name="project_desc" required
                       data-ph-ar="وصف مختصر"
                       data-ph-en="Short description"
                       placeholder="وصف مختصر" />
              </div>

              {/* <!-- 3 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="3. فئة النشاط" data-en="3. Business Category">3. فئة النشاط</span>
                  
                </label>
                <div className="options">
                  <label className="option"><input type="radio" name="activity_category" value="trade" required /><span data-ar="تجارة" data-en="Trade">تجارة</span></label>
                  <label className="option"><input type="radio" name="activity_category" value="services" /><span data-ar="خدمات" data-en="Services">خدمات</span></label>
                  <label className="option"><input type="radio" name="activity_category" value="tech" /><span data-ar="تقنية" data-en="Technology">تقنية</span></label>
                  <label className="option"><input type="radio" name="activity_category" value="industry" /><span data-ar="صناعة" data-en="Industry">صناعة</span></label>
                  <label className="option"><input type="radio" name="activity_category" value="agriculture" /><span data-ar="زراعة" data-en="Agriculture">زراعة</span></label>
                  <label className="option"><input type="radio" name="activity_category" value="logistics" /><span data-ar="لوجستيات" data-en="Logistics">لوجستيات</span></label>
                  <label className="option"><input type="radio" name="activity_category" value="education" /><span data-ar="تعليم" data-en="Education">تعليم</span></label>
                  <label className="option"><input type="radio" name="activity_category" value="health" /><span data-ar="صحة" data-en="Healthcare">صحة</span></label>
                  <label className="option"><input type="radio" name="activity_category" value="entertainment" /><span data-ar="ترفيه" data-en="Entertainment">ترفيه</span></label>
                  <label className="option"><input type="radio" name="activity_category" value="other" /><span data-ar="أخرى" data-en="Other">أخرى</span></label>
                </div>

                <div className="field">
                  <label htmlFor="activity_other">
                    <span data-ar="أخرى (نص)" data-en="Other (Text)">أخرى (نص)</span>
                  </label>
                  <input type="text" id="activity_other" name="activity_other" data-other-for="activity_category"
                         data-ph-ar="اكتب فئة النشاط الأخرى إن وجدت"
                         data-ph-en="Enter other category if applicable"
                         placeholder="اكتب فئة النشاط الأخرى إن وجدت" />
                </div>
              </div>

              {/* <!-- 4 --> */}
              <div className="field col-6">
                <label htmlFor="countryDisplay">
                  <span data-ar="4. الدولة المستهدفة" data-en="4. Target Country">4. الدولة المستهدفة</span>
                  
                </label>
                <div className="ss" id="countrySS">
                  <input type="text" id="countryDisplay" className="ss-value" required readOnly
                         data-ph-ar="اختر دولة أو أكثر" data-ph-en="Select one or more countries" placeholder="اختر دولة أو أكثر" />
                  <input type="hidden" id="countrySelect" name="target_country" required />
                  <div className="ss-panel" id="countryPanel" hidden>
                    <input type="text" id="countrySearch" className="ss-search"
                           data-ph-ar="ابحث عن الدولة..." data-ph-en="Search country..."
                           placeholder="ابحث عن الدولة..." autoComplete="off" />
                    <div className="ss-options" id="countryOptions" role="listbox" aria-label="country options"></div>
                  </div>
                </div>
              </div>

              {/* <!-- 5 --> */}
              <div className="field col-6">
                <label htmlFor="cityDisplay">
                  <span data-ar="5. المدينة المستهدفة (اختياري)" data-en="5. Target City (Optional)">5. المدينة المستهدفة (اختياري)</span>
                  
                </label>
                <div className="ss" id="citySS">
                  <input type="text" id="cityDisplay" className="ss-value" readOnly
                         data-ph-ar="اختر مدينة أو أكثر (اختياري)" data-ph-en="Select one or more cities (optional)" placeholder="اختر مدينة أو أكثر (اختياري)" />
                  <input type="hidden" id="citySelect" name="target_city" />
                  <div className="ss-panel" id="cityPanel" hidden>
                    <input type="text" id="citySearch" className="ss-search"
                           data-ph-ar="ابحث عن المدينة..." data-ph-en="Search city..."
                           placeholder="ابحث عن المدينة..." autoComplete="off" />
                    <div className="ss-options" id="cityOptions" role="listbox" aria-label="city options"></div>
                  </div>
                </div>
              </div>

              {/* <!-- 6 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="6. نوع العملاء المستهدفين" data-en="6. Target Customer Types">6. نوع العملاء المستهدفين</span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="checkbox" name="target_customers" value="individuals" data-required-group="target_customers" /><span data-ar="أفراد" data-en="Individuals">أفراد</span></label>
                  <label className="option"><input type="checkbox" name="target_customers" value="companies" data-required-group="target_customers" /><span data-ar="شركات" data-en="Companies">شركات</span></label>
                  <label className="option"><input type="checkbox" name="target_customers" value="government" data-required-group="target_customers" /><span data-ar="جهات حكومية" data-en="Government Entities">جهات حكومية</span></label>
                  <label className="option"><input type="checkbox" name="target_customers" value="non_profit" data-required-group="target_customers" /><span data-ar="منظمات غير ربحية" data-en="Nonprofits">منظمات غير ربحية</span></label>
                  <label className="option"><input type="checkbox" name="target_customers" value="other" data-required-group="target_customers" /><span data-ar="أخرى" data-en="Other">أخرى</span></label>
                </div>

                <div className="grid">
                  <div className="field col-8">
                    <label htmlFor="target_customers_other"><span data-ar="أخرى (نص)" data-en="Other (Text)">أخرى (نص)</span></label>
                    <input type="text" id="target_customers_other" name="target_customers_other"
                           data-ph-ar="اكتب نوع العملاء الآخر إن وجد"
                           data-ph-en="Enter other customer type if applicable"
                           placeholder="اكتب نوع العملاء الآخر إن وجد" />
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* <!-- ثانيًا: بيانات السوق المستهدف --> */}
          <div className="section">
            <h3 data-ar="ثانيًا: بيانات السوق المستهدف" data-en="2) Target Market Data">ثانيًا: بيانات السوق المستهدف</h3>
            <p className="hint" data-ar="أ. الخصائص الديموغرافية للجمهور" data-en="A. Audience demographics">أ. الخصائص الديموغرافية للجمهور</p>

            <div className="grid">
              {/* <!-- 7 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="7. الفئة العمرية المستهدفة" data-en="7. Target Age Range">7. الفئة العمرية المستهدفة</span>
                  
                </label>
                <div className="options">
                  <label className="option"><input type="checkbox" name="age_ranges" value="15_or_less" data-required-group="age_ranges" /><span data-ar="15 فما دون" data-en="15 or less">15 أو أقل</span></label>
                  <label className="option"><input type="checkbox" name="age_ranges" value="15-25" data-required-group="age_ranges" /><span>15–25</span></label>
                  <label className="option"><input type="checkbox" name="age_ranges" value="26-35" data-required-group="age_ranges" /><span>26–35</span></label>
                  <label className="option"><input type="checkbox" name="age_ranges" value="36-45" data-required-group="age_ranges" /><span>36–45</span></label>
                  <label className="option"><input type="checkbox" name="age_ranges" value="46-60" data-required-group="age_ranges" /><span>46–60</span></label>
                  <label className="option"><input type="checkbox" name="age_ranges" value="60plus" data-required-group="age_ranges" /><span>60+</span></label>
                </div>
              </div>

              {/* <!-- 8 --> */}
              <div className="field col-6">
                <label>
                  <span data-ar="8. الجنس" data-en="8. Gender">8. الجنس</span>
                  
                </label>
                <div className="options">
                  <label className="option"><input type="radio" name="gender" value="male" required /><span data-ar="ذكور" data-en="Male">ذكور</span></label>
                  <label className="option"><input type="radio" name="gender" value="female" /><span data-ar="إناث" data-en="Female">إناث</span></label>
                  <label className="option"><input type="radio" name="gender" value="both" /><span data-ar="كلاهما" data-en="Both">كلاهما</span></label>
                </div>
              </div>

              {/* <!-- 9 --> */}
              <div className="field col-6">
                <label>
                  <span data-ar="9. مستوى الدخل المتوقع للعميل" data-en="9. Expected Customer Income Level">9. مستوى الدخل المتوقع للعميل</span>
                  
                </label>
                <div className="options">
                  <label className="option"><input type="radio" name="income_level" value="low" required /><span data-ar="منخفض" data-en="Low">منخفض</span></label>
                  <label className="option"><input type="radio" name="income_level" value="medium" /><span data-ar="متوسط" data-en="Medium">متوسط</span></label>
                  <label className="option"><input type="radio" name="income_level" value="high" /><span data-ar="مرتفع" data-en="High">مرتفع</span></label>
                  <label className="option"><input type="radio" name="income_level" value="na" /><span data-ar="لا ينطبق" data-en="Not applicable">لا ينطبق</span></label>
                </div>
              </div>

              {/* <!-- 10 --> */}
              <div className="field col-12">
                <label htmlFor="geo_detail">
                  <span data-ar="10. الموقع الجغرافي الدقيق (إذا ينطبق)" data-en="10. Detailed geographic location (if applicable)">
                    10. الموقع الجغرافي الدقيق (إذا ينطبق)
                  </span>
                  
                </label>
                <input type="text" id="geo_detail" name="geo_detail"
                       data-ph-ar="اكتب تفاصيل إضافية عن الموقع"
                       data-ph-en="Enter additional location details"
                       placeholder="اكتب تفاصيل إضافية عن الموقع" />
              </div>

              {/* <!-- 11 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="11. هل توجد شرائح فرعية داخل الجمهور؟" data-en="11. Are there sub-segments within the audience?">
                    11. هل توجد شرائح فرعية داخل الجمهور؟
                  </span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="radio" name="sub_segments_choice" value="yes" required /><span data-ar="نعم" data-en="Yes">نعم</span></label>
                  <label className="option"><input type="radio" name="sub_segments_choice" value="no" /><span data-ar="لا" data-en="No">لا</span></label>
                </div>

                <div className="field is-hidden" id="sub_segments_wrap">
                  <label htmlFor="sub_segments"><span data-ar="نعم (مربع نص)" data-en="If yes (text box)">نعم (مربع نص)</span></label>
                  <textarea id="sub_segments" name="sub_segments" required disabled
                            data-ph-ar="اكتب الشرائح الفرعية إن وجدت"
                            data-ph-en="Describe sub-segments if any"
                            placeholder="اكتب الشرائح الفرعية إن وجدت"></textarea>
                </div>
              </div>

              {/* <!-- 12 --> */}

              <div className="field col-6">
                <label>
                  <span data-ar="12. النطاق الجغرافي المطلوب تحليل السوق فيه" data-en="12. Market analysis scope">
                    12. النطاق الجغرافي المطلوب تحليل السوق فيه
                  </span>
                  
                </label>
                <div className="options">
                  <label className="option"><input type="radio" name="market_scope" value="local" required /><span data-ar="محلي" data-en="Local">محلي</span></label>
                  <label className="option"><input type="radio" name="market_scope" value="regional" /><span data-ar="إقليمي" data-en="Regional">إقليمي</span></label>
                  <label className="option"><input type="radio" name="market_scope" value="international" /><span data-ar="دولي" data-en="International">دولي</span></label>
                </div>
              </div>

              {/* <!-- 13 --> */}
              <div className="field col-6">
                <label>
                  <span data-ar="13. هل تتوفر لديكم بيانات سابقة عن السوق؟" data-en="13. Do you have prior market data?">
                    13. هل تتوفر لديكم بيانات سابقة عن السوق؟
                  </span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="radio" name="has_market_data_choice" value="yes" required /><span data-ar="نعم" data-en="Yes">نعم</span></label>
                  <label className="option"><input type="radio" name="has_market_data_choice" value="no" /><span data-ar="لا" data-en="No">لا</span></label>
                </div>

                <div className="field is-hidden" id="market_data_file_wrap">
                  <label htmlFor="market_data_file"><span data-ar="أرفق ملف (اختياري)" data-en="Attach a file (optional)">أرفق ملف (اختياري)</span></label>
                  <input type="file" id="market_data_file" name="market_data_file" disabled />
                  <p className="small" data-ar="يمكنك رفع ملف واحد (اختياري ضمن خيار نعم)." data-en="You may upload one file (optional).">
                    يمكنك رفع ملف واحد (اختياري ضمن خيار نعم).
                  </p>
                </div>

                {/* <!-- Hidden field for key compatibility (has_market_data) --> */}
                <input type="hidden" id="has_market_data" name="has_market_data" value="" />
              </div>

            </div>
          </div>

          {/* <!-- ثالثًا: تحليل الطلب --> */}
          <div className="section">
            <h3 data-ar="ثالثًا: تحليل الطلب" data-en="3) Demand Analysis">ثالثًا: تحليل الطلب</h3>

            <div className="grid">
              {/* <!-- 14 --> */}
              <div className="field col-12">
                <label htmlFor="problem_solved">
                  <span data-ar="14. ما هي المشكلة الأساسية التي يحلها منتجك/خدمتك؟" data-en="14. What core problem does your product/service solve?">
                    14. ما هي المشكلة الأساسية التي يحلها منتجك/خدمتك؟
                  </span>
                  <span className="req" data-ar="(إلزامي)" data-en="">(إلزامي)</span>
                </label>
                <textarea id="problem_solved" name="problem_solved" required
                          data-ph-ar="اكتب المشكلة الأساسية"
                          data-ph-en="Describe the core problem"
                          placeholder="اكتب المشكلة الأساسية"></textarea>
              </div>

              {/* <!-- 15 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="15. ما هو الدافع الأكبر للعميل لاستخدام المنتج؟" data-en="15. What is the biggest motive for customers?">
                    15. ما هو الدافع الأكبر للعميل لاستخدام المنتج؟
                  </span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="checkbox" name="main_motives" value="cost" data-required-group="main_motives" /><span data-ar="تقليل التكاليف" data-en="Reduce costs">تقليل التكاليف</span></label>
                  <label className="option"><input type="checkbox" name="main_motives" value="time" data-required-group="main_motives" /><span data-ar="توفير الوقت" data-en="Save time">توفير الوقت</span></label>
                  <label className="option"><input type="checkbox" name="main_motives" value="quality" data-required-group="main_motives" /><span data-ar="تحسين الجودة" data-en="Improve quality">تحسين الجودة</span></label>
                  <label className="option"><input type="checkbox" name="main_motives" value="solve_problem" data-required-group="main_motives" /><span data-ar="حل مشكلة محددة" data-en="Solve a specific problem">حل مشكلة محددة</span></label>
                  <label className="option"><input type="checkbox" name="main_motives" value="ease" data-required-group="main_motives" /><span data-ar="الراحة والسهولة" data-en="Convenience & ease">الراحة والسهولة</span></label>
                  <label className="option"><input type="checkbox" name="main_motives" value="other" data-required-group="main_motives" /><span data-ar="أخرى" data-en="Other">أخرى</span></label>
                </div>

                <div className="grid">
                  <div className="field col-8">
                    <label htmlFor="main_motives_other"><span data-ar="أخرى (نص)" data-en="Other (Text)">أخرى (نص)</span></label>
                    <input type="text" id="main_motives_other" name="main_motives_other"
                           data-ph-ar="اكتب الدافع الآخر إن وجد"
                           data-ph-en="Enter other motive if applicable"
                           placeholder="اكتب الدافع الآخر إن وجد" />
                  </div>
                </div>
              </div>

              {/* <!-- 16 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="16. هل هناك موسمية للطلب؟" data-en="16. Is demand seasonal?">16. هل هناك موسمية للطلب؟</span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="radio" name="seasonal_demand_choice" value="yes" required /><span data-ar="نعم" data-en="Yes">نعم</span></label>
                  <label className="option"><input type="radio" name="seasonal_demand_choice" value="no" /><span data-ar="لا" data-en="No">لا</span></label>
                </div>

                <div className="field is-hidden" id="season_periods_wrap">
                  <label htmlFor="season_periods"><span data-ar="نعم (حدد الفترات نص)" data-en="If yes (specify periods)">نعم (حدد الفترات نص)</span></label>
                  <textarea id="season_periods" name="season_periods" required disabled
                            data-ph-ar="اكتب الفترات/المواسم إن وجدت"
                            data-ph-en="Specify seasons/periods if applicable"
                            placeholder="اكتب الفترات/المواسم إن وجدت"></textarea>
                </div>

                {/* <!-- Hidden field for key compatibility (seasonal_demand) --> */}
                <input type="hidden" id="seasonal_demand" name="seasonal_demand" value="" />
              </div>

              {/* <!-- 17 --> */}

              <div className="field col-6">
                <label>
                  <span data-ar="17. تقدير الطلب المتوقع في السنة الأولى" data-en="17. Expected demand in year 1">
                    17. تقدير الطلب المتوقع في السنة الأولى
                  </span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="radio" name="first_year_demand" value="low" required /><span data-ar="منخفض" data-en="Low">منخفض</span></label>
                  <label className="option"><input type="radio" name="first_year_demand" value="medium" /><span data-ar="متوسط" data-en="Medium">متوسط</span></label>
                  <label className="option"><input type="radio" name="first_year_demand" value="high" /><span data-ar="مرتفع" data-en="High">مرتفع</span></label>
                  
                </div>
              </div>
<div className="field col-12">
  <label>
    <span
      data-ar="تقدير رقمي للطلب في السنة الأولى (اختياري)"
      data-en="Estimated numeric demand in year 1 (optional)"
    >
      تقدير رقمي للطلب في السنة الأولى (اختياري)
    </span>
  </label>

  <div className="grid">

    <div className="field col-6">
      <label htmlFor="first_year_demand_value">
        <span data-ar="القيمة" data-en="Value">
          القيمة
        </span>
      </label>

      <input
        type="number"
        id="first_year_demand_value"
        name="first_year_demand_value"
        min="0"
        data-ph-ar="مثال: 8000"
        data-ph-en="Example: 8000"
        placeholder="مثال: 8000"
      />
    </div>

    <div className="field col-6">
      <label htmlFor="first_year_demand_unit">
        <span data-ar="الوحدة" data-en="Unit">
          الوحدة
        </span>
      </label>

      <select
        id="first_year_demand_unit"
        name="first_year_demand_unit"
        defaultValue=""
      >
        <option value="" disabled>
          {language === "ar" ? "اختر الوحدة" : "Select unit"}
        </option>

        <option value="unit">
          {language === "ar" ? "وحدة / قطعة" : "Units / Pieces"}
        </option>

        <option value="kg">
          {language === "ar" ? "كيلوغرام" : "Kilogram"}
        </option>

        <option value="ton">
          {language === "ar" ? "طن" : "Ton"}
        </option>

        <option value="liter">
          {language === "ar" ? "لتر" : "Liter"}
        </option>

        <option value="cubic_meter">
          {language === "ar" ? "متر مكعب" : "Cubic Meter"}
        </option>

        <option value="customer">
          {language === "ar" ? "عميل / مستفيد" : "Customer / Beneficiary"}
        </option>

        <option value="order">
          {language === "ar" ? "طلب / معاملة" : "Order / Transaction"}
        </option>

        <option value="service_hour">
          {language === "ar" ? "ساعة خدمة" : "Service Hour"}
        </option>
<option value="percent">
  {language === "ar" ? "نسبة مئوية (%)" : "Percentage (%)"}
</option>
       
      </select>
    </div>

  </div>
</div>
            </div>
          </div>

          {/* <!-- رابعًا: تحليل العرض --> */}
          <div className="section">
            <h3 data-ar="رابعًا: تحليل العرض" data-en="4) Supply Analysis">رابعًا: تحليل العرض</h3>

            <div className="grid">
              {/* <!-- 18 --> */}
              <div className="field col-12">
                <label htmlFor="current_alternatives">
                  <span data-ar="18. أبرز البدائل الحالية في السوق (مفصولة بفواصل)" data-en="18. Key alternatives in the market (comma-separated)">
                    18. أبرز البدائل الحالية في السوق (مفصولة بفواصل)
                  </span>
                  
                </label>
                <input type="text" id="current_alternatives" name="current_alternatives" required
                       data-ph-ar="مثال: بديل1, بديل2, بديل3"
                       data-ph-en="Example: Alternative1, Alternative2, Alternative3"
                       placeholder="مثال: بديل1, بديل2, بديل3" />
              </div>

              {/* <!-- 19 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="19. ما هي ميزة منتجك الأساسية مقارنة بالبدائل؟" data-en="19. Your core advantage vs alternatives">
                    19. ما هي ميزة منتجك الأساسية مقارنة بالبدائل؟
                  </span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="checkbox" name="core_advantage" value="price" data-required-group="core_advantage" /><span data-ar="السعر" data-en="Price">السعر</span></label>
                  <label className="option"><input type="checkbox" name="core_advantage" value="quality" data-required-group="core_advantage" /><span data-ar="الجودة" data-en="Quality">الجودة</span></label>
                  <label className="option"><input type="checkbox" name="core_advantage" value="innovation" data-required-group="core_advantage" /><span data-ar="الابتكار" data-en="Innovation">الابتكار</span></label>
                  <label className="option"><input type="checkbox" name="core_advantage" value="usability" data-required-group="core_advantage" /><span data-ar="سهولة الاستخدام" data-en="Ease of use">سهولة الاستخدام</span></label>
                  <label className="option"><input type="checkbox" name="core_advantage" value="after_sales" data-required-group="core_advantage" /><span data-ar="خدمة ما بعد البيع" data-en="After-sales service">خدمة ما بعد البيع</span></label>
                  <label className="option"><input type="checkbox" name="core_advantage" value="other" data-required-group="core_advantage" /><span data-ar="أخرى" data-en="Other">أخرى</span></label>
                </div>

                <div className="grid">
                  <div className="field col-8">
                    <label htmlFor="core_advantage_other"><span data-ar="أخرى (نص)" data-en="Other (Text)">أخرى (نص)</span></label>
                    <input type="text" id="core_advantage_other" name="core_advantage_other"
                           data-ph-ar="اكتب الميزة الأخرى إن وجدت"
                           data-ph-en="Enter other advantage if applicable"
                           placeholder="اكتب الميزة الأخرى إن وجدت" />
                  </div>
                </div>
              </div>

              {/* <!-- 20 --> */}
             {/* <!-- 20 --> */}
<div className="field col-12">
  <label>
    <span
      data-ar="20. الطاقة الإنتاجية/الاستيعابية المتوقعة شهريًا"
      data-en="20. Expected monthly capacity"
    >
      20. الطاقة الإنتاجية/الاستيعابية المتوقعة شهريًا
    </span>
  </label>

  <div className="grid">

    <div className="field col-6">
      <label htmlFor="monthly_capacity">
        <span
          data-ar="القيمة"
          data-en="Capacity value"
        >
          القيمة
        </span>
      </label>

      <input
        type="number"
        id="monthly_capacity"
        name="monthly_capacity"
        required
        min="0"
        data-ph-ar="مثال: 10000"
        data-ph-en="Example: 10000"
        placeholder="مثال: 10000"
      />
    </div>

    <div className="field col-6">
      <label htmlFor="capacity_unit">
        <span
          data-ar="الوحدة"
          data-en="Unit"
        >
          الوحدة
        </span>
      </label>

      <select
        id="capacity_unit"
        name="capacity_unit"
        required
        defaultValue=""
      >
        <option value="" disabled>
          {language === "ar" ? "اختر الوحدة" : "Select unit"}
        </option>

        <option value="unit">
          {language === "ar" ? "وحدة / قطعة" : "Units / Pieces"}
        </option>

        <option value="kg">
          {language === "ar" ? "كيلوغرام" : "Kilogram"}
        </option>

        <option value="ton">
          {language === "ar" ? "طن" : "Ton"}
        </option>

        <option value="liter">
          {language === "ar" ? "لتر" : "Liter"}
        </option>

        <option value="cubic_meter">
          {language === "ar" ? "متر مكعب" : "Cubic Meter"}
        </option>

        <option value="customer">
          {language === "ar" ? "عميل / مستفيد" : "Customer / Beneficiary"}
        </option>

        <option value="order">
          {language === "ar" ? "طلب / معاملة" : "Order / Transaction"}
        </option>

        <option value="service_hour">
          {language === "ar" ? "ساعة خدمة" : "Service Hour"}
        </option>
<option value="percent">
  {language === "ar" ? "نسبة مئوية (%)" : "Percentage (%)"}
</option>
       
      </select>
    </div>

  </div>
</div>
            </div>
          </div>

          {/* <!-- خامسًا: تحليل المنافسين --> */}
          <div className="section">
            <h3 data-ar="خامسًا: تحليل المنافسين" data-en="5) Competitor Analysis">خامسًا: تحليل المنافسين</h3>

            <div className="grid">
              {/* <!-- 21 --> */}
              <div className="field col-12">
                <label htmlFor="competitors_names">
                  <span data-ar="21. أسماء المنافسين المباشرين (مفصولة بفواصل)" data-en="21. Direct competitors (comma-separated)">
                    21. أسماء المنافسين المباشرين (مفصولة بفواصل)
                  </span>
                  
                </label>
                <input type="text" id="competitors_names" name="competitors_names"
                       data-ph-ar="منافس1, منافس2, منافس3"
                       data-ph-en="Competitor1, Competitor2, Competitor3"
                       placeholder="منافس1, منافس2, منافس3" />
              </div>

              {/* <!-- 22 --> */}
              <div className="field col-12">
                <label htmlFor="competitors_products_desc">
                  <span data-ar="22. صف المنتجات المنافسة كل على حدة" data-en="22. Describe competing products (each separately)">
                    22. صف المنتجات المنافسة كل على حدة
                  </span>
                  
                </label>
                <textarea id="competitors_products_desc" name="competitors_products_desc"
                          data-ph-ar="اكتب وصف المنتجات المنافسة"
                          data-ph-en="Describe competitors' products"
                          placeholder="اكتب وصف المنتجات المنافسة"></textarea>
              </div>

              {/* <!-- 23 --> */}
              <div className="field col-6">
                <label>
                  <span data-ar="23. مستوى أسعار المنافسين" data-en="23. Competitors' price level">23. مستوى أسعار المنافسين</span>
                  
                </label>
                <div className="options">
                  <label className="option"><input type="radio" name="competitor_price_level" value="low" required /><span data-ar="منخفضة" data-en="Low">منخفضة</span></label>
                  <label className="option"><input type="radio" name="competitor_price_level" value="medium" /><span data-ar="متوسطة" data-en="Medium">متوسطة</span></label>
                  <label className="option"><input type="radio" name="competitor_price_level" value="high" /><span data-ar="مرتفعة" data-en="High">مرتفعة</span></label>
                </div>
              </div>

              {/* <!-- 24 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="24. نقاط قوة المنافسين" data-en="24. Competitors' strengths">24. نقاط قوة المنافسين</span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="checkbox" name="competitor_strengths" value="prices" data-required-group="competitor_strengths" /><span data-ar="الأسعار" data-en="Prices">الأسعار</span></label>
                  <label className="option"><input type="checkbox" name="competitor_strengths" value="quality" data-required-group="competitor_strengths" /><span data-ar="الجودة" data-en="Quality">الجودة</span></label>
                  <label className="option"><input type="checkbox" name="competitor_strengths" value="brand" data-required-group="competitor_strengths" /><span data-ar="العلامة التجارية" data-en="Brand">العلامة التجارية</span></label>
                  <label className="option"><input type="checkbox" name="competitor_strengths" value="coverage" data-required-group="competitor_strengths" /><span data-ar="التغطية الجغرافية" data-en="Geographic coverage">التغطية الجغرافية</span></label>
                  <label className="option"><input type="checkbox" name="competitor_strengths" value="variety" data-required-group="competitor_strengths" /><span data-ar="تنوع المنتجات" data-en="Product variety">تنوع المنتجات</span></label>
                  <label className="option"><input type="checkbox" name="competitor_strengths" value="marketing" data-required-group="competitor_strengths" /><span data-ar="قوة التسويق" data-en="Marketing strength">قوة التسويق</span></label>
                  <label className="option"><input type="checkbox" name="competitor_strengths" value="technology" data-required-group="competitor_strengths" /><span data-ar="التكنولوجيا" data-en="Technology">التكنولوجيا</span></label>
                  <label className="option"><input type="checkbox" name="competitor_strengths" value="other" data-required-group="competitor_strengths" /><span data-ar="أخرى" data-en="Other">أخرى</span></label>
                </div>

                <div className="grid">
                  <div className="field col-8">
                    <label htmlFor="competitor_strengths_other"><span data-ar="أخرى (نص)" data-en="Other (Text)">أخرى (نص)</span></label>
                    <input type="text" id="competitor_strengths_other" name="competitor_strengths_other"
                           data-ph-ar="اكتب نقطة قوة أخرى إن وجدت"
                           data-ph-en="Enter other strength if applicable"
                           placeholder="اكتب نقطة قوة أخرى إن وجدت" />
                  </div>
                </div>
              </div>

              {/* <!-- 25 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="25. نقاط ضعف المنافسين" data-en="25. Competitors' weaknesses">25. نقاط ضعف المنافسين</span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="checkbox" name="competitor_weaknesses" value="customer_service" data-required-group="competitor_weaknesses" /><span data-ar="خدمة العملاء" data-en="Customer service">خدمة العملاء</span></label>
                  <label className="option"><input type="checkbox" name="competitor_weaknesses" value="low_flexibility" data-required-group="competitor_weaknesses" /><span data-ar="مرونة منخفضة" data-en="Low flexibility">مرونة منخفضة</span></label>
                  <label className="option"><input type="checkbox" name="competitor_weaknesses" value="high_prices" data-required-group="competitor_weaknesses" /><span data-ar="أسعار عالية" data-en="High prices">أسعار عالية</span></label>
                  <label className="option"><input type="checkbox" name="competitor_weaknesses" value="old_tech" data-required-group="competitor_weaknesses" /><span data-ar="تقنيات قديمة" data-en="Outdated tech">تقنيات قديمة</span></label>
                  <label className="option"><input type="checkbox" name="competitor_weaknesses" value="weak_digital" data-required-group="competitor_weaknesses" /><span data-ar="ضعف التواجد الرقمي" data-en="Weak digital presence">ضعف التواجد الرقمي</span></label>
                  <label className="option"><input type="checkbox" name="competitor_weaknesses" value="other" data-required-group="competitor_weaknesses" /><span data-ar="أخرى" data-en="Other">أخرى</span></label>
                </div>

                <div className="grid">
                  <div className="field col-8">
                    <label htmlFor="competitor_weaknesses_other"><span data-ar="أخرى (نص)" data-en="Other (Text)">أخرى (نص)</span></label>
                    <input type="text" id="competitor_weaknesses_other" name="competitor_weaknesses_other"
                           data-ph-ar="اكتب نقطة ضعف أخرى إن وجدت"
                           data-ph-en="Enter other weakness if applicable"
                           placeholder="اكتب نقطة ضعف أخرى إن وجدت" />
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* <!-- سادسًا: تحليل الفجوات والفرص --> */}
          <div className="section">
            <h3 data-ar="سادسًا: تحليل الفجوات والفرص" data-en="6) Gaps & Opportunities">سادسًا: تحليل الفجوات والفرص</h3>

            <div className="grid">
              {/* <!-- 26 --> */}
              <div className="field col-12">
                <label htmlFor="market_gaps">
                  <span data-ar="26. ما هي الفجوات التي لاحظتها في السوق؟" data-en="26. What market gaps have you observed?">
                    26. ما هي الفجوات التي لاحظتها في السوق؟
                  </span>
                  
                </label>
                <textarea id="market_gaps" name="market_gaps" required
                          data-ph-ar="اكتب الفجوات"
                          data-ph-en="Describe market gaps"
                          placeholder="اكتب الفجوات"></textarea>
              </div>

              {/* <!-- 27 --> */}
              <div className="field col-12">
                <label htmlFor="market_opportunities">
                  <span data-ar="27. ما هي الفرص المحتملة التي يمكن استغلالها؟" data-en="27. What opportunities can be leveraged?">
                    27. ما هي الفرص المحتملة التي يمكن استغلالها؟
                  </span>
                  
                </label>
                <textarea id="market_opportunities" name="market_opportunities" required
                          data-ph-ar="اكتب الفرص"
                          data-ph-en="Describe opportunities"
                          placeholder="اكتب الفرص"></textarea>
              </div>

              {/* <!-- 28 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="28. هل توجد شرائح غير مخدومة في السوق؟" data-en="28. Are there underserved segments?">
                    28. هل توجد شرائح غير مخدومة في السوق؟
                  </span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="radio" name="underserved_segments_choice" value="yes" required /><span data-ar="نعم" data-en="Yes">نعم</span></label>
                  <label className="option"><input type="radio" name="underserved_segments_choice" value="no" /><span data-ar="لا" data-en="No">لا</span></label>
                </div>

                <div className="field is-hidden" id="underserved_segments_wrap">
                  <label htmlFor="underserved_segments_text"><span data-ar="نعم (حددها)" data-en="If yes (specify)">نعم (حددها)</span></label>
                  <textarea id="underserved_segments_text" name="underserved_segments_text" required disabled
                            data-ph-ar="اكتب الشرائح غير المخدومة"
                            data-ph-en="Describe underserved segments"
                            placeholder="اكتب الشرائح غير المخدومة"></textarea>
                </div>

                <input type="hidden" id="underserved_segments" name="underserved_segments" value="" />
              </div>

              {/* <!-- 29 --> */}

              <div className="field col-12">
                <label>
                  <span data-ar="29. هل توجد تغييرات مستقبلية قد تؤثر على السوق؟" data-en="29. Future changes that may impact the market">
                    29. هل توجد تغييرات مستقبلية قد تؤثر على السوق؟
                  </span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="checkbox" name="future_changes" value="regulatory" data-required-group="future_changes" /><span data-ar="تغيرات تشريعية" data-en="Regulatory changes">تغيرات تشريعية</span></label>
                  <label className="option"><input type="checkbox" name="future_changes" value="tech" data-required-group="future_changes" /><span data-ar="تغيرات تقنية" data-en="Technology changes">تغيرات تقنية</span></label>
                  <label className="option"><input type="checkbox" name="future_changes" value="behavior" data-required-group="future_changes" /><span data-ar="تحولات في سلوك العملاء" data-en="Customer behavior shifts">تحولات في سلوك العملاء</span></label>
                  <label className="option"><input type="checkbox" name="future_changes" value="economic" data-required-group="future_changes" /> <span
    data-ar="تغيرات اقتصادية"
    data-en="Economic changes"
  >
    تغيرات اقتصادية
  </span></label>
                  <label className="option"><input type="checkbox" name="future_changes" value="other" data-required-group="future_changes" /><span data-ar="أخرى" data-en="Other">أخرى</span></label>
                </div>

                <div className="grid">
                  <div className="field col-8">
                    <label htmlFor="future_changes_other"><span data-ar="أخرى (نص)" data-en="Other (Text)">أخرى (نص)</span></label>
                    <input type="text" id="future_changes_other" name="future_changes_other"
                           data-ph-ar="اكتب التغيير الآخر إن وجد"
                           data-ph-en="Enter other change if applicable"
                           placeholder="اكتب التغيير الآخر إن وجد" />
                  </div>
                </div>
              </div>

            </div>
          </div>

          {/* <!-- سابعًا: احتياجات وسلوك العملاء --> */}
          <div className="section">
            <h3 data-ar="سابعًا: احتياجات وسلوك العملاء" data-en="7) Customer Needs & Behavior">سابعًا: احتياجات وسلوك العملاء</h3>

            <div className="grid">
              {/* <!-- 30 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="30. أهم أسباب قرار الشراء للعملاء" data-en="30. Main purchase decision factors">
                    30. أهم أسباب قرار الشراء للعملاء
                  </span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="checkbox" name="purchase_reasons" value="price" data-required-group="purchase_reasons" /><span data-ar="السعر" data-en="Price">السعر</span></label>
                  <label className="option"><input type="checkbox" name="purchase_reasons" value="quality" data-required-group="purchase_reasons" /><span data-ar="الجودة" data-en="Quality">الجودة</span></label>
                  <label className="option">
  <input
    type="checkbox"
    name="purchase_reasons"
    value="availability"
    data-required-group="purchase_reasons"
  />
  <span
    data-ar="توفر المنتج / استمرارية التوريد"
    data-en="Availability / Supply reliability"
  >
    توفر المنتج / استمرارية التوريد
  </span>
</label>
                  <label className="option"><input type="checkbox" name="purchase_reasons" value="speed" data-required-group="purchase_reasons" /><span data-ar="سرعة الخدمة" data-en="Service speed">سرعة الخدمة</span></label>
                  <label className="option"><input type="checkbox" name="purchase_reasons" value="trust" data-required-group="purchase_reasons" /><span data-ar="الثقة بالعلامة" data-en="Brand trust">الثقة بالعلامة</span></label>
                  <label className="option"><input type="checkbox" name="purchase_reasons" value="ux" data-required-group="purchase_reasons" /><span data-ar="تجربة المستخدم" data-en="User experience">تجربة المستخدم</span></label>
                  <label className="option"><input type="checkbox" name="purchase_reasons" value="after_sales" data-required-group="purchase_reasons" /><span data-ar="خدمة ما بعد البيع" data-en="After-sales service">خدمة ما بعد البيع</span></label>
                  <label className="option"><input type="checkbox" name="purchase_reasons" value="customization" data-required-group="purchase_reasons" /><span data-ar="التخصيص" data-en="Customization">التخصيص</span></label>
                </div>
              </div>

              {/* <!-- 31 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="31. قناة الشراء المفضلة" data-en="31. Preferred purchase channel">
                    31. قناة الشراء المفضلة
                  </span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="checkbox" name="preferred_channel" value="physical" data-required-group="preferred_channel" /><span data-ar="متجر فعلي" data-en="Physical store">متجر فعلي</span></label>
                  <label className="option"><input type="checkbox" name="preferred_channel" value="web" data-required-group="preferred_channel" /><span data-ar="منصة إلكترونية" data-en="Website">منصة إلكترونية</span></label>
                  <label className="option"><input type="checkbox" name="preferred_channel" value="app" data-required-group="preferred_channel" /><span data-ar="تطبيق" data-en="App">تطبيق</span></label>
                  <label className="option"><input type="checkbox" name="preferred_channel" value="direct" data-required-group="preferred_channel" /><span data-ar="التواصل المباشر" data-en="Direct contact">التواصل المباشر</span></label>
                  <label className="option"><input type="checkbox" name="preferred_channel" value="agents" data-required-group="preferred_channel" /><span data-ar="وكلاء" data-en="Agents">وكلاء</span></label>
                  <label className="option"><input type="checkbox" name="preferred_channel" value="other" data-required-group="preferred_channel" /><span data-ar="أخرى" data-en="Other">أخرى</span></label>
                </div>

                <div className="grid">
                  <div className="field col-8">
                    <label htmlFor="preferred_channel_other"><span data-ar="أخرى (نص)" data-en="Other (Text)">أخرى (نص)</span></label>
                    <input type="text" id="preferred_channel_other" name="preferred_channel_other"
                           data-ph-ar="اكتب القناة الأخرى إن وجدت"
                           data-ph-en="Enter other channel if applicable"
                           placeholder="اكتب القناة الأخرى إن وجدت" />
                  </div>
                </div>
              </div>

              {/* <!-- 32 --> */}
              <div className="field col-12">
                <label htmlFor="pain_points">
                  <span data-ar="32. نقاط الألم الحالية للعملاء (Pain Points)" data-en="32. Current customer pain points">
                    32. نقاط الألم الحالية للعملاء (Pain Points)
                  </span>
                  
                </label>
                <textarea id="pain_points" name="pain_points" required
                          data-ph-ar="اكتب نقاط الألم"
                          data-ph-en="Describe pain points"
                          placeholder="اكتب نقاط الألم"></textarea>
              </div>

              {/* <!-- 33 --> */}
              <div className="field col-12">
                <label htmlFor="customer_expectations">
                  <span data-ar="33. توقعات العملاء من المنتج/الخدمة" data-en="33. Customer expectations of the product/service">
                    33. توقعات العملاء من المنتج/الخدمة
                  </span>
                  
                </label>
                <textarea id="customer_expectations" name="customer_expectations" required
                          data-ph-ar="اكتب توقعات العملاء"
                          data-ph-en="Describe expectations"
                          placeholder="اكتب توقعات العملاء"></textarea>
              </div>

            </div>
          </div>

          {/* <!-- ثامنًا: مرفقات اختيارية --> */}
          <div className="section">
            <h3 data-ar="ثامنًا: مرفقات اختيارية" data-en="8) Optional Attachments">ثامنًا: مرفقات اختيارية</h3>

            <div className="grid">
              {/* <!-- 34 --> */}
              <div className="field col-12">
                <label>
                  <span data-ar="34. هل ترغب بإرفاق أي ملفات/عروض/صور؟" data-en="34. Would you like to attach files/presentations/images?">
                    34. هل ترغب بإرفاق أي ملفات/عروض/صور؟
                  </span>
                  
                </label>

                <div className="options">
                  <label className="option"><input type="radio" id="attachmentsYes" name="attachments_choice" value="yes" /><span data-ar="نعم" data-en="Yes">نعم</span></label>
                  <label className="option"><input type="radio" id="attachmentsNo" name="attachments_choice" value="no" /><span data-ar="لا" data-en="No">لا</span></label>
                </div>

                <div className="field is-hidden" id="attachmentsFiles_wrap">
  <label htmlFor="attachmentsFiles">
    <span data-ar="رفع ملفات" data-en="Upload files">
      رفع ملفات
    </span>
  </label>

  <input
    type="file"
    id="attachmentsFiles"
    name="attachments_files"
    multiple
    disabled
    onChange={(event) => {
      const input = event.currentTarget;
      const newFiles = Array.from(input.files || []);

      const mergedFiles = [
        ...attachmentFiles,
        ...newFiles,
      ].filter(
        (file, index, array) =>
          index ===
          array.findIndex(
            (item) =>
              item.name === file.name &&
              item.size === file.size &&
              item.lastModified === file.lastModified
          )
      );

      const dataTransfer = new DataTransfer();

      mergedFiles.forEach((file) => {
        dataTransfer.items.add(file);
      });

      input.files = dataTransfer.files;

      setAttachmentFiles(mergedFiles);
    }}
  />

  <p
    className="small"
    data-ar="يمكنك رفع عدة ملفات."
    data-en="You can upload multiple files."
  >
    يمكنك رفع عدة ملفات.
  </p>

  {attachmentFiles.length > 0 && (
    <div className="uploaded-files-list">
      {attachmentFiles.map((file, index) => (
        <div
          className="uploaded-file-item"
          key={`${file.name}-${file.size}-${file.lastModified}-${index}`}
        >
          <span>{file.name}</span>

          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              const input =
                document.getElementById("attachmentsFiles");

              const nextFiles = attachmentFiles.filter(
                (_, fileIndex) => fileIndex !== index
              );

              if (input) {
                const dataTransfer = new DataTransfer();

                nextFiles.forEach((item) => {
                  dataTransfer.items.add(item);
                });

                input.files = dataTransfer.files;
              }

              setAttachmentFiles(nextFiles);
            }}
          >
            {language === "ar" ? "إزالة" : "Remove"}
          </button>
        </div>
      ))}
    </div>
  )}
</div>
              </div>
            </div>
          </div>

          <div className="section">
            <h3 data-ar="تاسعًا: ملاحظات إضافية" data-en="9) Additional Notes">تاسعًا: ملاحظات إضافية</h3>

            <div className="grid">
              <div className="field col-12">
                <label htmlFor="additional_notes">
                  <span data-ar="35. أي معلومات ترى أنها مهمة لبناء الدراسة؟" data-en="35. Any information you think is important for building the study?">
                    35. أي معلومات ترى أنها مهمة لبناء الدراسة؟
                  </span>
                  
                </label>
                <textarea id="additional_notes" name="additional_notes"
                          data-ph-ar="اكتب أي ملاحظات إضافية"
                          data-ph-en="Write any additional notes"
                          placeholder="اكتب أي ملاحظات إضافية"></textarea>
              </div>
            </div>
          </div>
</fieldset>
          {generationStatus && (
            <div className="generation-status" role="status" aria-live="polite">
              <div className="generation-spinner" aria-hidden="true"></div>
              <div className="generation-copy">
                <strong>
                  {language === "ar"
                    ? "جارٍ توليد الدراسة"
                    : "Generating study"}
                </strong>
               <span>
  {language === "ar"
    ? "قد يستغرق إعداد الدراسة من 15 إلى 30 دقيقة. لا تغلق الصفحة إذا أردت استلام الملف مباشرة. عند اكتمال التوليد ستحصل الآن على الملخص التنفيذي فقط، بينما تُرسل الدراسة الشاملة للمراجعة والتدقيق، ثم يتم تسليمها لك لاحقًا عبر البريد الإلكتروني بصيغتها النهائية."
    : "Preparing the study may take approximately 15 to 30 minutes. Keep this page open if you want to receive the file directly. Once generation is complete, you will receive the executive summary only, while the full study will be reviewed and quality-checked, then delivered to you later by email in its final form."}
</span>
                <small>
                  {language === "ar" ? "الوقت المنقضي: " : "Elapsed time: "}
                  {formatGenerationTime(generationStatus.startedAt)}
                </small>
              </div>
              <button
                type="button"
                className="btn btn-secondary generation-cancel"
                onClick={handleCancelGeneration}
              >
                {language === "ar" ? "إلغاء" : "Cancel"}
              </button>
            </div>
          )}

          <div className="actions">
 <button
  id="generateBtn"
  type="button"
  className="btn btn-primary"
  onClick={handleGenerateClick}
disabled={isGenerating || generationCompleted}>
 {generationCompleted
  ? language === "ar"
    ? "تم توليد الدراسة بنجاح"
    : "Study Generated Successfully"
  : isGenerating
    ? language === "ar"
      ? "جارٍ توليد الدراسة..."
      : "Generating study..."
    : language === "ar"
      ? "توليد الدراسة"
      : "Generate Study"}
</button>

  <button
  type="button"
  onClick={exportSavedWord}
  style={{
    marginLeft: "10px",
    padding: "10px 18px",
    cursor: "pointer",
  }}
>
  🔄 إعادة توليد Word
</button>

</div>

        </form>
      </div>
    </div>
  </div>

  );
 }

export default Marketsurvey;

